import React, { useContext, useEffect, useState } from 'react';
import { SocketContext } from './SocketContext.js';
import Countdown from "../components/Countdown";
import SoundManager from './SoundManager.js';

const StatusBar = () => {
    let socket = useContext(SocketContext);

    const [statusText, setStatusText] = useState('');
    const [showCountdown, setShowCountdown] = useState(false);
    const [key, setKey] = useState(0);
    var clearStatusTimer = null;

    function clearStatus() {
        setStatusText('');
    }

    function onTimerComplete(){
        setShowCountdown(false);
    }

    useEffect(() => {
        if (socket) {

            const handleStatus = (data) => {
                if (clearStatusTimer)
                    clearTimeout(clearStatusTimer);
                setStatusText(data.status); // Assuming you want to display the data received
                var duration = 3500;
                if (data.duration)
                    duration = data.duration;
                
                if (duration > 0) {
                    clearStatusTimer = setTimeout(clearStatus, duration);
                }
            };

            socket.on('status', handleStatus);
            socket.on('hideoverlay', empty => {
                setShowCountdown(true);
                //make the timer reset
                setKey(prevKey => prevKey + 1);
            });

            socket.on('egc', empty => {
                if (clearStatusTimer) //TODO does this work or will it always be null?
                    clearTimeout(clearStatusTimer);
                    
                setShowCountdown(false);
                setStatusText('');
                //make the timer reset
                setKey(prevKey => prevKey + 1);
                SoundManager.stopAllSounds();
            });

        }

        return () => {
            if (socket)
                socket.off('status');
                socket.off('hideoverlay');
                socket.off('egc');
        };
    }, []);


    return (
        showCountdown ? <><span className="countdown"><Countdown key={key} duration={90} onComplete={onTimerComplete}></Countdown></span>
        <span className="statustext">{statusText}</span></>:
        <>
            <span className="statustext">{statusText}</span>
        </>
    );
};

export default StatusBar;